import { PaymentTermsSchema } from "@src/sudozi-schemas/payment-terms.schema";
import { z } from "zod";

export const ServiceListingSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  createdAt: z.string().datetime(),
  archived: z.boolean(),
  paymentFrequency: z
    .enum([
      "MONTHLY",
      "WEEKLY",
      "BIWEEKLY",
      "QUARTERLY",
      "ANNUALLY",
      "BIANNUALLY",
      "ONE_TIME",
      "OTHER",
    ])
    .nullable(),
  paymentTerm: PaymentTermsSchema,
  autorenews: z.boolean(),
  spendCategory: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  owners: z
    .object({
      id: z.string(),
      email: z.string(),
      firstName: z.string(),
      lastName: z.string(),
    })
    .array(),
  departments: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .array(),
  businessUnit: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  vendor: z.object({
    id: z.string(),
    name: z.string(),
  }),
  servicePeriods: z
    .object({
      id: z.string(),
      startDate: z.string(),
      endDate: z.string().nullable(),
      costPerUnit: z.number().nullable(),
      unitsPerMonth: z.number().nullable(),
      totalServicePeriodCost: z.number(),
      tax: z.number().nullable(),
      renewalReminderDates: z.string().array(),
      archived: z.boolean().nullish(),
      currency: z.string().nullable(),
      customColumns: z
        .object({
          id: z.string(),
          ordinal: z.number(),
          display: z.string(),
          intakeQuestionId: z.string().nullable(),
          value: z.string().nullable(),
        })
        .array()
        .optional(),
    })
    .array(),
  customColumns: z
    .array(
      z.object({
        id: z.string(),
        ordinal: z.number(),
        display: z.string(),
        intakeQuestionId: z.string().nullable(),
        value: z.string().nullable(),
      }),
    )
    .optional(),
});

export type ServiceListingSchema = z.infer<typeof ServiceListingSchema>;
